import { BrowserModule } from '@angular/platform-browser';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA, APP_INITIALIZER } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { AppRoutingModule } from './app-routing.module';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { CacheStorage } from './shared/services/cache-storage.service';
import { CacheInterceptor } from './core/interceptors/cache.interceptor';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';

import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { OAuthModule, OAuthService, UrlHelperService } from 'angular-oauth2-oidc';
import { WindowRef } from './shared/services/window-ref.service';
import { CardRenewalModule } from './pages/card-renewal/card-renewal.module';
import { FooterComponent } from './shared/components/footer/footer.component';
import { WellbeingHubModule } from './pages/wellbeing-hub/wellbeing-hub.module';

import { BeforeYouStartModule } from './pages/before-you-start/before-you-start.module';
import { CoreModule } from './core/core.module';
import { MaterialModule } from './shared/material.module';
import { NavbarComponent } from './shared/components/navbar/navbar.component';
import { AppConfigService } from './shared/services/app-config.service';
import { ChatBotModule } from './pages/chatbot/chat.module';
import { PageNotFoundComponent } from './pages/errors/page-not-found/page-not-found.component';
import { AuthGuard } from './shared/guards/auth.guard';
import { SomethingWentWrongComponent } from './pages/errors/something-went-wrong/something-went-wrong.component';
import { TooManyRequestsComponent } from './pages/errors/too-many-requests/too-many-requests.component';
import { TooManyRequestsInterceptor } from './core/interceptors/too-many-requests.interceptor';

export function app_config(serverConfigService: AppConfigService) {
  return () => serverConfigService.loadAppConfig();
}

@NgModule({
  declarations: [
    AppComponent,
    NavbarComponent,
    FooterComponent,
    PageNotFoundComponent,
    SomethingWentWrongComponent,
    TooManyRequestsComponent
  ],
  imports: [
    BrowserModule.withServerTransition({ appId: 'ng-cli-universal' }),
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
    MatFormFieldModule,
    MatSelectModule,
    MatInputModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    OAuthModule.forRoot(),
    CardRenewalModule,
    WellbeingHubModule,
    BeforeYouStartModule,
    ChatBotModule,
    CoreModule,
  ],
  providers: [
    OAuthService,
    UrlHelperService,
    WindowRef,
    AuthGuard,
    { provide: HTTP_INTERCEPTORS, useClass: CacheInterceptor, deps: [OAuthService, CacheStorage], multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: TooManyRequestsInterceptor, multi: true },
    { provide: APP_INITIALIZER, useFactory: app_config, deps: [AppConfigService], multi: true },
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }

